// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_34ZrAH","title":"_2mcDg1","subtitleBox":"_3LBS36","inChronicle":"_1viWEM","navigationItemsBox":"EzEQkd"};